import { detectSubjectType, defineAbility, createAliasResolver, AbilityBuilder, Ability } from '@casl/ability';

export const customDetectSubjectType = (subject) => {
  if (subject && typeof subject === 'object' && subject.__type) {
    return subject.__type;
  }

  return detectSubjectType(subject);
}

const options = { detectSubjectType: customDetectSubjectType };

export const customDefineAbility = (rules) => {
  return defineAbility(options, rules)
}

const resolveAction = createAliasResolver({
  modify: ['update', 'delete']
});

function hasRole(profile = {}, role) {
  // return true;
  return profile?.privileges?.includes(role) ?? false
}

function createBasicRuleFor(profile, can, privilege) {
  if (hasRole(profile, privilege)) {
    can(privilege);
  }
}


export function defineAbilityFor(profile) {
  const { can, cannot, build } = new AbilityBuilder(Ability);

  if (profile.isAdmin) {
    // can('manage', 'all'); // read-write access to everything
  }

  // Contract permissions
  can('modify', 'Contract', ['watchers', 'collaboration', 'voters'], { 'user._id': profile._id });
  can('modify', 'Contract', { 'user': profile._id });
  can('modify', 'Contract', { 'user._id': profile._id });
  can('modify', 'Template', { 'user': profile._id });
  can('modify', 'Template', { 'user._id': profile._id });

  if (hasRole(profile, 'CREATE_VOTE')) {

  }
  if (hasRole(profile, 'VIEW_CONTRACT_PROPERTIES')) {
    can('read', 'Contract', ['properties']);
  }
  if (hasRole(profile, 'VIEW_COLLABORATION')) {
    can('read', 'Contract', ['collaboration']);
  }
  if (hasRole(profile, 'VIEW_PAYMENTS')) {
    can('read', 'Contract', ['payments']);
  }
  if (hasRole(profile, 'VIEW_MILESTONES')) {
    can('read', 'Contract', ['milestones']);
  }
  if (hasRole(profile, 'DELEGATE_IN_COLLABORATION')) {
    can('delegate-in-collaboration', 'Contract');
  }
  if (hasRole(profile, 'ASSIGN_CONTRACT')) {
    can('assign', 'Contract');
  }
  if (hasRole(profile, 'ASSIGN_IN_COLLABORATION')) {
    can('assign-in-collaboration', 'Contract');
  }
  if (hasRole(profile, 'REQUEST_CORRECTION')) {
    can('request-correction', 'Contract');
  }
  if (hasRole(profile, 'DOWNLOAD_PACKAGE')) {
    can('download-package', 'Contract');
  }
  if (hasRole(profile, 'SET_EXTRA_EXPIRE')) {
    can('set-expire', 'Contract', ['extra-attachments']);
  }
  if (hasRole(profile, 'SET_PARTICIPANT_ATTACHMENT_EXPIRE')) {
    can('set-expire', 'Contract', ['participant-attachments']);
  }
  if (hasRole(profile, 'ATTACHMENT_VALIDATION')) {
    can('validate', 'Contract', ['participant-attachments']);
    can('validate', 'Contract', ['extra-attachments']);
  }
  if (hasRole(profile, 'CONVERT_CONTRACT')) {
    can('convert', 'Contract');
  }
  if (hasRole(profile, 'SET_AS_SIGNED')) {
    can('set_signed', 'Contract');
  }
  if (hasRole(profile, 'VIEW_ADMIN_PROFILE')) {
    can('read', 'Admin-Profile');
  }
  if (hasRole(profile, 'VIEW_WALLET')) {
    can('read', 'Own-Wallet');
  }
  if (hasRole(profile, 'VIEW_PROCESSES')) {
    can('read', 'Profile-Processes')
  }

  createBasicRuleFor(profile, can, 'VIEW_EXTERNALID');
  createBasicRuleFor(profile, can, 'VIEW_SET_WORKFLOWS');
  createBasicRuleFor(profile, can, 'LOCK_TEMPLATE');
  createBasicRuleFor(profile, can, 'ADD_TEMPLATE_DESCRIPTION');
  createBasicRuleFor(profile, can, 'SET_REQUIRE_VALIDATION');
  createBasicRuleFor(profile, can, 'CREATE_VOTING');
  createBasicRuleFor(profile, can, 'SET_STAMP_APPROVAL');
  createBasicRuleFor(profile, can, 'SET_SHOW_NUMBER');
  createBasicRuleFor(profile, can, 'CREATE_SHAREDOCS_PROTECTED');
  createBasicRuleFor(profile, can, 'SET_NOTIFY_ALL');
  createBasicRuleFor(profile, can, 'SET_NOTIFY_ALL_SIGNED_TO_PARTICIPANTS');
  createBasicRuleFor(profile, can, 'SET_SHIELD3_STATEMENT');
  createBasicRuleFor(profile, can, 'SET_REQUIRE_CHECK_CONFIRMATION');
  createBasicRuleFor(profile, can, 'ADD_SPECTATOR');
  createBasicRuleFor(profile, can, 'SET_CONTRACT_PARTICIPANT_VIEW_EXPIRATION');
  createBasicRuleFor(profile, can, 'SET_NOTIFICATIONS');
  createBasicRuleFor(profile, can, 'VIEW_EXTRACT_INFO');
  createBasicRuleFor(profile, can, 'APPLY_VARIABLES_WORD_ONLINE');
  createBasicRuleFor(profile, can, 'SET_QUESTIONS');
  createBasicRuleFor(profile, can, 'SHARE_TEMPLATE');
  createBasicRuleFor(profile, can, 'VIEW_SET_SUGGESTIONS');
  createBasicRuleFor(profile, can, 'IMPORT_VARIABLES_FROM_EXCEL');
  createBasicRuleFor(profile, can, 'READ_VARIABLES_FROM_WORD');
  createBasicRuleFor(profile, can, 'REQUEST_VIDEO_RECORDING');
  createBasicRuleFor(profile, can, 'REQUEST_VERIDOC');
  createBasicRuleFor(profile, can, 'REQUEST_INE');
  createBasicRuleFor(profile, can, 'REQUEST_MANDATORY_LOCATION');
  createBasicRuleFor(profile, can, 'REQUEST_SHIELD_4');
  createBasicRuleFor(profile, can, 'SET_GROUP_VALIDATION');
  createBasicRuleFor(profile, can, 'SET_CONTRACT_PARTICIPANT_VIEW_EXPIRATION');
  createBasicRuleFor(profile, can, 'VIEW_COLLABORATION_COMMENTS');
  createBasicRuleFor(profile, can, 'NEGOTIATION_WORD');
  createBasicRuleFor(profile, can, 'OPEN_IN_WORD_ONLINE');
  createBasicRuleFor(profile, can, 'DOUBLECLICK_TEMPLATE_TO_CONTRACT');
  createBasicRuleFor(profile, can, 'REQUEST_INE_OCR');
  createBasicRuleFor(profile, can, 'SET_CUSTOM_MESSAGE');
  createBasicRuleFor(profile, can, 'HIDE_MINIDASHBOARDS');
  createBasicRuleFor(profile, can, 'INIT_WORKFLOW_FRONTDESK');
  createBasicRuleFor(profile, can, 'CREATE_TESTAMENT');
  createBasicRuleFor(profile, can, 'DOWNLOAD_REPORT_IN_CONTRACT_LIST');
  createBasicRuleFor(profile, can, 'SET_REFUSE_SIGNATURE');
  createBasicRuleFor(profile, can, 'CREATE_WORD_TEMPLATE');
  createBasicRuleFor(profile, can, 'CREATE_PDF_TEMPLATE');
  createBasicRuleFor(profile, can, 'SET_PRE_APPROVED_TEMPLATE');
  createBasicRuleFor(profile, can, 'SET_MEDICAL_PRESCRIPTION');
  createBasicRuleFor(profile, can, 'REQUEST_ONE_TIME_PASSWORD');
  createBasicRuleFor(profile, can, 'SET_VIDEO_DECLARATION');
  createBasicRuleFor(profile, can, 'VIEW_ZOOM_INTEGRATION');
  createBasicRuleFor(profile, can, 'SHARE_SUGGESTIONS');
  createBasicRuleFor(profile, can, 'SET_WORKFLOW_FRONTDESK');

  // Page permissions
  createBasicRuleFor(profile, can, 'VIEW_DASHBOARD');
  createBasicRuleFor(profile, can, 'VIEW_RECORDS');
  createBasicRuleFor(profile, can, 'VIEW_FRONTDESK');
  createBasicRuleFor(profile, can, 'VIEW_CONTRACTS_LIST');
  createBasicRuleFor(profile, can, 'VIEW_REPORTS_2');
  createBasicRuleFor(profile, can, 'VIEW_AGENDA');
  createBasicRuleFor(profile, can, 'VIEW_INCOMING_CONTRACTS');
  createBasicRuleFor(profile, can, 'VIEW_TEMPLATES');
  createBasicRuleFor(profile, can, 'VIEW_WORKFLOW');
  createBasicRuleFor(profile, can, 'VIEW_RISKS');
  createBasicRuleFor(profile, can, 'VIEW_BLOCKCHAIN');
  createBasicRuleFor(profile, can, 'VIEW_METADATA_SEARCH');
  createBasicRuleFor(profile, can, 'VIEW_MANUAL');
  createBasicRuleFor(profile, can, 'VIEW_EDITOR');
  createBasicRuleFor(profile, can, 'VIEW_USER_FORMS');

  // Dashboard permission
  createBasicRuleFor(profile, can, 'DASHBOARD_VIEW_BALANCE');
  createBasicRuleFor(profile, can, 'DASHBOARD_VIEW_CONTRACT_STAGES');
  createBasicRuleFor(profile, can, 'DASHBOARD_VIEW_CONTRACT_TYPES');
  createBasicRuleFor(profile, can, 'DASHBOARD_VIEW_SIGNED_CONTRACTS');
  createBasicRuleFor(profile, can, 'DASHBOARD_VIEW_COUNTER_RECENTLY_APPROVED');
  createBasicRuleFor(profile, can, 'DASHBOARD_VIEW_COUNTER_DRAFTS');
  createBasicRuleFor(profile, can, 'DASHBOARD_VIEW_SIGNED_CONTRACTS');

  // Create contract permissions
  createBasicRuleFor(profile, can, 'CREATE_NEW_APPLICATION');
  createBasicRuleFor(profile, can, 'CREATE_NEW_PAGARE');
  createBasicRuleFor(profile, can, 'CREATE_NEW_EXTERNAL');
  createBasicRuleFor(profile, can, 'CREATE_NEW_MASSIVE');
  createBasicRuleFor(profile, can, 'CREATE_NEW_MIGRATE');
  createBasicRuleFor(profile, can, 'CREATE_NEW_BLANK');
  createBasicRuleFor(profile, can, 'CREATE_NEW_UPLOAD');
  createBasicRuleFor(profile, can, 'CREATE_NEW_QUESTIONNAIRE');
  createBasicRuleFor(profile, can, 'CREATE_NEW_TEMPLATE');

  // Reports permissions
  createBasicRuleFor(profile, can, 'VIEW_ONLY_SELF_EMAIL_REPORT');

  // Workflow permissions
  can('modify', 'Workflow', { 'creator': profile._id })
  can('modify', 'Workflow', { 'creator._id': profile._id })
  can('remove', 'Workflow', { 'creator': profile._id })
  can('remove', 'Workflow', { 'creator._id': profile._id })

  return build({
    detectSubjectType: customDetectSubjectType,
    resolveAction
  });
}